import styled from 'styled-components'

export const Root = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  & .MuiTabs-root {
    margin-bottom: 10px;
  }
`

export const Wrapper = styled.div`
  align-items: baseline;
  display: flex;
  margin-bottom: 10px;
`
